import { createContext } from 'react';

import { SortingContextStore } from './sorting-context.store';

export const SortingContext = createContext<SortingContextStore<any, any>>(null!);
